import requestFunctions from "../../functions/requestFunctions";


export const state = {
  FINANCE_TYPES_ITEM: {},
  FINANCE_TYPES_LIST: [],
  FINANCE_TYPES_TABLE_DATA: [],
  FINANCE_TYPES_ARRAY_DATA: [],
  FINANCE_TYPES_TOTAL_ROWS: 0
}

export const getters = {
  GET_FINANCE_TYPES_ITEM: (state) => {
    return state.FINANCE_TYPES_ITEM;
  },
  GET_FINANCE_TYPES_LIST: (state) => {
    return state.FINANCE_TYPES_LIST;
  },
  GET_FINANCE_TYPES_TABLE_DATA: (state) => {
    return state.FINANCE_TYPES_TABLE_DATA;
  },
  GET_FINANCE_TYPES_ARRAY_DATA: (state) => {
    return state.FINANCE_TYPES_ARRAY_DATA;
  },
  GET_FINANCE_TYPES_TOTAL_ROWS: (state) => {
    return state.FINANCE_TYPES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_FINANCE_TYPES_ITEM(state, item) {
    state.FINANCE_TYPES_ITEM = item;
  },

  UPDATE_FINANCE_TYPES_LIST(state, list) {
    
    state.FINANCE_TYPES_LIST = list.data;

    state.FINANCE_TYPES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.FINANCE_TYPES_TABLE_DATA = [];
    state.FINANCE_TYPES_ARRAY_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active')  { status = 'Активна' }
      if(el.status === 'wait')    { status = 'Ожидается' }
      if(el.status === 'paused')  { status = 'Приостановлена' }
      if(el.status === 'blocked') { status = 'Заблокирована' }
      if(el.status === 'stopped') { status = 'Остановлена' }

      state.FINANCE_TYPES_TABLE_DATA.push({
        'name' : el.name,
        'code' : el.code,
        'uuid' : el.uuid,
        'status' : status,
        'id'   : el.id,
      });

      state.FINANCE_TYPES_ARRAY_DATA.push({
        id: el.id,
        name: el.name,
        code: el.code,
        uuid: el.uuid,
        status: el.status
      });
    });
  },
}

export const actions = {

  async FETCH_FINANCE_TYPES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/types/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_TYPES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_FINANCE_TYPES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/types';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FINANCE_TYPES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_FINANCE_TYPES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/types';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_TYPES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/types/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_FINANCE_TYPES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/finance/types/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}